import styled from 'styled-components'
import { Typography } from 'common/typography'
import Wrapper from 'common/wrapper'
import { usePortfolio } from 'querys/portfolio'
import PortfolioProject from './portfolio-project'

const PortfolioProjectsStyled = styled.section`
  padding-block-start: 24px;
  padding-block-end: 24px;
  h2 {
    display: none;
  }
  .projects-grid {
    display: grid;
    gap: 48px;
  }
  @media (min-width: 768px) {
    .projects-grid {
      grid-template-columns: 1fr 1fr;
    }
  }
  @media (min-width: 1024px) {
    padding-block-start: 80px;
    padding-block-end: 80px;
    h2 {
      display: block;
      margin-block-end: 40px;
    }
  }
  @media (min-width: 1366px) {
    .projects-grid {
      grid-template-columns: 1fr 1fr;
    }
  }
`

function PortfolioProjects() {
  const { data: { projects } } = usePortfolio()
  return (
    <PortfolioProjectsStyled id="proyectos" role="navigation" aria-labelledby="last-projects">
      <Wrapper maxWidth={1200}>
        <Typography as="h2" font="headline2" id="last-projects">
          Mis proyectos
        </Typography>
        <ul className="projects-grid">
          {projects.map((project) => <PortfolioProject key={project.title} {...project} />)}
        </ul>
      </Wrapper>
    </PortfolioProjectsStyled>
  )
}

export default PortfolioProjects
